import React, { useCallback, useContext, useMemo } from 'react';
import { SELECT_INPUT_OPTION_DIVIDER_TYPE, SlideOutComp } from '@moderepo/mode-app-components';
import { hideSlideOutPanel, modeUIContext } from '@moderepo/mode-ui-state';
import { DeviceCommandSettings, SendDeviceCommandContainer } from '.';



export interface SendDeviceCommandSlideOutContainerProps {
    readonly projectId: number;
    readonly deviceId: number;
    readonly predefinedCommands?: readonly (DeviceCommandSettings | SELECT_INPUT_OPTION_DIVIDER_TYPE)[] | undefined;
    readonly disableCustomCommand?: boolean | undefined;
}


/**
 * This container is used for displaying the oSendDeviceCommand component in a slide out panel. This component doesn't do much,
 * all it does is show the SendDeviceCommandContainer
 */
export const SendDeviceCommandSlideOutContainer = (props: SendDeviceCommandSlideOutContainerProps) => {
    const { dispatch:uiDispatch } = useContext(modeUIContext);


    /**
     * Unselected the current selected Alert entity
     */
    const hidePreviewPanel = useCallback(() => {
        uiDispatch(hideSlideOutPanel());
    }, [uiDispatch]);


    const onCompletedHandler = useCallback(() => {
        hidePreviewPanel();
    }, [hidePreviewPanel]);


    const slideOutCompContent = useMemo(() => {
        return (
            <SendDeviceCommandContainer
                className="transparent"
                infoCompProps={{
                    formProps: {
                        className: 'single-column',
                    },
                }}
                projectId={props.projectId}
                deviceId={props.deviceId}
                predefinedCommands={props.predefinedCommands}
                disableCustomCommand={props.disableCustomCommand}
                onCompleted={onCompletedHandler}
            />
        );
    }, [props.projectId, props.deviceId, props.predefinedCommands, props.disableCustomCommand, onCompletedHandler]);


    return (
        <SlideOutComp
            compContent={slideOutCompContent}
            closable={false}
            hideActionBar={true}
            contentContainerProps={{
                className: 'slide-out-comp-container',
            }}
        />
    );
};
